"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
// Interval (in milliseconds) that keyboard strokes will be debounced before being sent to the event handler
exports.DEFAULT_DEBOUNCE_TIME = 200;
//# sourceMappingURL=constants.js.map